import {
  DialogDescription,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogClose,
  DialogTitle,
  Button,
  Dialog,
} from '@ui/components';
import { useTranslation } from 'react-i18next';

interface UnsavedChangesDialogProps {
  isPending: boolean;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onSave: () => void;
}

export const UnsavedChangesDialog = (props: UnsavedChangesDialogProps) => {
  const { onSave, isPending, isOpen, setIsOpen } = props;

  const { t } = useTranslation();

  return (
    <Dialog onOpenChange={setIsOpen} open={isOpen}>
      <DialogContent onOpenAutoFocus={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>{t('COMPANY_POLICY.UNSAVED_CHANGES_TITLE')}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{t('COMPANY_POLICY.UNSAVED_CHANGES_DESCRIPTION')}</DialogDescription>
        <DialogFooter>
          <DialogClose asChild>
            <Button disabled={isPending} variant="tertiary" type="button" size="large" wide>
              {t('COMPANY_POLICY.UNSAVED_CHANGES_CANCEL')}
            </Button>
          </DialogClose>
          <Button
            onClick={() => onSave()}
            isLoading={isPending}
            disabled={isPending}
            size="large"
            wide
          >
            {t('COMPANY_POLICY.UNSAVED_CHANGES_CONTINUE_ANYWAY')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
